import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { RaRecord, useCreate } from 'react-admin';

import { BOResourceAll } from '@Common/types/bo_external/resources';

type SafeCreateFn<Req extends object, Res extends RaRecord> = (
  resource: BOResourceAll,
  params: { data: Req; previousData?: Res },
) => Promise<Res>;

export function useCreatePromise<Req extends object, Res extends RaRecord = RaRecord>(): [
  SafeCreateFn<Req, Res>,
  { isLoading: boolean; isError: boolean },
] {
  const [create, { isLoading, isError }] = useCreate();
  const safeCreate = useCallback(
    async (resource: BOResourceAll, params: { data: Req; previousData?: Res }) =>
      (await create(resource, params, { returnPromise: true })) as Res,
    [create],
  );

  return [safeCreate, { isLoading, isError }];
}
